<template>
  <center-layout-form title="パスワード変更">
    <template slot="body">
      <el-form ref="form" :model="form" :rules="rules" autocomplete="off">
        <el-form-item prop="username">
          <el-input
            size="large"
            v-model="form.username"
            :maxlength="1024"
            placeholder="ユーザ名"
            autofocus
            :disabled="true"
          >
            <template slot="prepend">
              <i class="fa fa-user fa-fw fg-silver"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="current_password">
          <el-input
            size="large"
            type="password"
            v-model="form.current_password"
            :maxlength="1024"
            placeholder="現在のパスワード"
          >
            <template slot="prepend">
              <i class="fa fa-key fa-fw fg-silver"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            size="large"
            type="password"
            v-model="form.password"
            :maxlength="1024"
            placeholder="新パスワード"
          >
            <template slot="prepend">
              <i class="fa fa-key fa-fw fg-silver"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="verify_password">
          <el-input
            size="large"
            type="password"
            v-model="form.verify_password"
            :maxlength="1024"
            placeholder="新パスワード(確認用)"
            @keyup.enter.native="onSubmit('form')"
          >
            <template slot="prepend">
              <i class="fa fa-key fa-fw fg-silver"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            size="large"
            class="login"
            type="primary"
            @click="onSubmit('form')"
            :loading="loading"
          >パスワード変更</el-button>
          <el-button size="large" class="login" @click="onCancel()">キャンセル</el-button>
        </el-form-item>
        <el-alert v-if="isAlert" :title="errorMessage" type="error" show-icon :closable="false"></el-alert>
      </el-form>
    </template>
  </center-layout-form>
</template>

<script>
import axios from "axios";
import CenterLayoutForm from "@/components/CenterLayoutForm";

export default {
  components: {
    CenterLayoutForm
  },
  data: function() {
    var validatePass = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(
          new Error("新パスワードと新パスワード(確認用)が一致していません")
        );
      } else {
        callback();
      }
    };
    return {
      isAlert: false,
      loading: false,
      errorMessage: "",
      form: {
        username: "",
        current_password: "",
        password: "",
        verify_password: ""
      },
      rules: {
        current_password: [
          {
            required: true,
            message: "現在のパスワードを入力してください",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "新パスワードを入力してください",
            trigger: "blur"
          }
        ],
        verify_password: [
          {
            required: true,
            message: "新パスワード(確認用)を入力してください",
            trigger: "blur"
          },
          { validator: validatePass, trigger: "blur" }
        ]
      }
    };
  },
  created() {
    axios
      .get("/api/accounts/profile/")
      .then(response => {
        this.form.username = response.data.username;
      })
      .catch(error => {
        console.log(error);
        if (error.response.status === 403) {
          this.form.username = error.response.data.username;
        } else {
          this.$router.push({ name: "login" });
        }
      });
  },
  methods: {
    onSubmit(formName) {
      this.isAlert = false;
      this.loading = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          axios
            .post("/api/accounts/change-password/", this.form)
            .then(() => {
              this.$router.push({ name: "login", query: this.$route.query });
            })
            .catch(error => {
              this.loading = false;
              if (error.response.status === 400) {
                let e = error.response.data;
                console.log(e);
                if (Array.isArray(e)) {
                  this.errorMessage = e.join(",");
                } else {
                  if ("non_field_errors" in e) {
                    this.errorMessage = e.non_field_errors.join(",");
                  } else if ("detail" in e) {
                    this.errorMessage = e.detail;
                  } else if (typeof e === "object") {
                    this.errorMessage = Object.values(e).join("");
                  } else {
                    this.errorMessage = e;
                  }
                }
              } else {
                this.errorMessage = "パスワード変更に失敗しました";
              }
              this.isAlert = true;
            });
        } else {
          this.loading = false;
          return false;
        }
      });
    },
    onCancel() {
      history.back();
    }
  }
};
</script>

<style scoped>
.login {
  width: 45%;
}
</style>
